/* global axios */
import ApiClient from './ApiClient';

class MessageForwardingApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  forward({ sourceId, messageIds, destinationIds, requestId }) {
    return axios.post(
      `${this.url}/${sourceId}/message_forwards`,
      {
        message_ids: messageIds,
        destination_ids: destinationIds,
        request_id: requestId,
      },
      { timeout: 60000 }
    );
  }

  status({ sourceId, requestId }) {
    return axios.get(`${this.url}/${sourceId}/message_forwards`, {
      params: { request_id: requestId },
      timeout: 15000,
    });
  }
}

export default new MessageForwardingApi();
